// Horizontal tab navigation for the household detail page.
// Tabs are real routes (per architectural decision) so they're deep-linkable
// and browser back/forward works between them.

import { NavLink } from 'react-router-dom';

const TABS = [
  { path: 'overview',   label: 'Overview' },
  // URL stays /members for stable bookmarks; visible label updated post-A.5
  // when "members" became people (humans) vs engagements.
  { path: 'members',    label: 'People' },
  { path: 'wealth',     label: 'Wealth (BWM)' },
  { path: 'tax',        label: 'Tax (BTS)' },
  { path: 'insurance',  label: 'Insurance (BIA)' },
  { path: 'cross-sell', label: 'Cross-Sell' },
  { path: 'portal',     label: 'Portal' },
  { path: 'activity',   label: 'Activity' },
];

export default function HouseholdTabBar({ householdId }) {
  return (
    <div className="bg-white rounded-[4px] shadow-[0_2px_6px_rgba(0,0,0,0.07)] px-2 py-0 overflow-x-auto">
      <nav className="flex items-center gap-1 min-w-max">
        {TABS.map(tab => (
          <NavLink
            key={tab.path}
            to={`/crm/households/${encodeURIComponent(householdId)}/${tab.path}`}
            className={({ isActive }) =>
              `text-[12px] font-bold px-4 py-3 transition-colors border-b-2 ${
                isActive
                  ? 'text-bullogic-blue border-bullogic-blue'
                  : 'text-[#888] border-transparent hover:text-navy hover:border-gray-200'
              }`
            }
          >
            {tab.label}
          </NavLink>
        ))}
      </nav>
    </div>
  );
}
